// yt-consent.js – DSGVO Click-to-Load (strict): lädt NUR bei Marketing=YES
(function(){
  // JS aktiv -> Fallback-Overlay ausblenden
  document.documentElement.classList.add('js-yt-ready');
  console.log('[YT] JS ready (strict)');

  function mountIframe(box){
    if(!box || box.dataset.mounted) return;
    var id = box.getAttribute('data-ytid');
    var title = box.getAttribute('data-title') || 'YouTube Video';
    var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

    console.log('[YT] mount iframe →', id);
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = title;
    iframe.loading = 'lazy';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    Object.assign(iframe.style, {position:'absolute', inset:'0', width:'100%', height:'100%', border:'0', display:'block'});

    var fb = box.querySelector('.yt-fallback-link'); if(fb) fb.remove();
    box.replaceChildren(iframe);
    box.dataset.mounted = '1';
  }

  function showConsentHint(box){
    var p = box.querySelector('.yt-consent__hint');
    if(p && !p.dataset.extended){
      p.insertAdjacentHTML('beforeend','<br><small>Bitte Marketing-Cookies erlauben, um das Video zu laden.</small>');
      p.dataset.extended = '1';
      console.log('[YT] marketing=false/unknown → hint shown');
    }
  }

  // Normalisiert verschiedenste Rückgaben der Shopify-Privacy-API
  function normalizeConsent(val){
    // Mögliche Formen:
    //  - Objekt: { marketing: true/false, ... }
    //  - String: 'yes' | 'no' | 'tbd' | 'unknown'
    //  - Boolean (theoretisch)
    if (val == null) return 'unknown';
    if (typeof val === 'string') return val.toLowerCase();
    if (typeof val === 'boolean') return val ? 'yes' : 'no';
    if (typeof val === 'object') {
      if ('marketing' in val) return val.marketing ? 'yes' : 'no';
      if ('status' in val && typeof val.status === 'string') return val.status.toLowerCase();
    }
    return 'unknown';
  }

  // Strikte Ermittlung: nur 'yes' erlaubt
  function getMarketingAllowedStrict(){
    return new Promise(function(resolve){
      try{
        var priv = window.Shopify && Shopify.customerPrivacy;
        if(!priv || typeof priv.getTrackingConsent !== 'function'){
          console.warn('[YT] no privacy API → treat as NOT allowed');
          resolve(false);
          return;
        }

        var fn = priv.getTrackingConsent;
        var done = function(consent){
          var status = normalizeConsent(consent);
          var allow = (status === 'yes'); // NUR yes erlaubt
          console.log('[YT] consent normalized:', status, '→ allow=', allow);
          resolve(allow);
        };

        // Callback-API
        if(fn.length >= 1){
          fn(function(consent){ done(consent); });
          return;
        }
        // Promise-API
        var result = fn();
        if(result && typeof result.then === 'function'){
          result.then(done).catch(function(err){
            console.warn('[YT] consent promise error → NOT allowed', err);
            resolve(false);
          });
          return;
        }
        // Synchrone Rückgabe
        done(result);
      } catch(e){
        console.warn('[YT] consent check failed → NOT allowed', e);
        resolve(false);
      }
    });
  }

  function handle(box){
    if(!box) return;
    getMarketingAllowedStrict().then(function(ok){
      if(ok){ mountIframe(box); }
      else { showConsentHint(box); }
    });
  }

  function onClick(e){
    var box = e.target.closest && e.target.closest('.yt-consent');
    if(!box) return;
    var isButtonOrFallback = e.target.closest('.yt-consent__btn, .yt-fallback-link');
    if(isButtonOrFallback){ e.preventDefault(); }
    console.log('[YT] click on consent box');
    handle(box);
  }

  function onKey(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var box = e.target.closest && e.target.closest('.yt-consent');
    if(!box) return;
    e.preventDefault();
    console.log('[YT] key press on consent box:', e.key);
    handle(box);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);
})();
